module.exports = __webpack_public_path__ + "img/arrecredihome1v_vdr.10563c52.webp";